import {ChangeDetectionStrategy, Component, HostBinding, Input} from '@angular/core';

@Component({
    selector:        'dex-lp-part-plate',
    templateUrl:     './dex-lp-part-plate.component.html',
    styleUrl:        './dex-lp-part-plate.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DexLpPartPlateComponent {

    @Input()
    @HostBinding('class.-collapsed')
    public isCollapsed: boolean;

    @Input()
    @HostBinding('class.-expand-collapse')
    public isExpandCollapseEnabled: boolean;

}
